import {Dispatcher} from "../../../stem-core/src/base/Dispatcher.js";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils.js";
import {PaymentMethodStore} from "../../State.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {encryptJSON} from "../../../client/crypto/encryptJSON.js";
import {authService} from "../../../client/connection/services/AuthService.js";
import {ApiErrors} from "../../../client/connection/ApiErrors.js";
import {Messages} from "../../Messages.js";


export const CARD_SECTION_STATE = {
    chooseCard: "chooseCard",
    payWithAddedCard: "payWithAddedCard",
    usingCard: "usingCard",
    addCard: "addCard",
};

export class PaymentMethodController extends Dispatcher {
    cardHolderName = "";
    cardSectionState = null;
    initialPaymentMethod = null;
    selectedPaymentMethod = null;
    showSaveCardCheckbox = true; // If you want to allow an iframe option to override this, track where this variable is used
    entry = null;
    savePaymentMethod = true;
    getPayWithAddedCardButtonLabel = () => Messages.finalizePayment;
    getChooseCardButtonLabel = () => Messages.finalizePayment;
    onSelectSuccess = NOOP_FUNCTION;
    retryPayment = null;
    getScope = NOOP_FUNCTION;
    paymentError = null;
    altPayData = null; // For

    async extractPaymentInfoForCDS() {
        const {altPayData} = this;
        if (altPayData) {
            return `${altPayData.provider.value}-${altPayData.orderId}`
        }
        const {cardNumber, cardExpiry, cardCvv} = (this.selectedPaymentMethod || {});
        return encryptJSON({
            card_number: cardNumber,
            card_expiry: cardExpiry,
            card_cvv: cardCvv,
        }, authService.appSettings.blinkPaymentMethodEncryptionPublicKey);
    }

    setAltPayOrderId(provider, orderId) {
        // If provider is null, clear the field
        const altPayData = provider && {
            provider,
            orderId,
        }
        this.update({altPayData});
    }

    async extractPaymentMethodFields() {
        if (iFrameMerchantService.isCDSPaymentMethod()) {
            const paymentInfo = await this.extractPaymentInfoForCDS();
            return {paymentInfo};
        }
        return {
            preferredPaymentMethodId: this.selectedPaymentMethod?.id,
        }
    }

    constructor(options={}) {
        super(options);

        this.update(options);
    }

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }

    getInitialPaymentMethod() {
        return this.initialPaymentMethod || (PaymentMethodStore.getPrimary() || PaymentMethodStore.getAvailablePaymentMethods()[0]);
    }

    // Try to initialize the default payment method
    autoselectPaymentMethod() {
        if (!this.selectedPaymentMethod) {
            this.selectedPaymentMethod = this.getInitialPaymentMethod();
            this.initialPaymentMethod = this.selectedPaymentMethod;
        }
    }

    getPaymentErrorMessage() {
        if (this.paymentError && this.paymentError.code === ApiErrors.CDS_NEW_ORDER_ERROR) {
            return "";
        }
        return this.paymentError?.message || "";
    }

    isCDSPaymentError() {
        return this.paymentError?.code >= 9000 && this.paymentError?.code <= 9100;
    }
}
